var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"sidebar-container",class:{'hiddenMenu': !_vm.showMenu,'left': _vm.direction == 'left','top': _vm.direction == 'top', 'right': _vm.direction == 'right'}},[_c('el-scrollbar',{attrs:{"wrap-class":"scrollbar-wrapper"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }